import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Chair = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 10C24.448 10 24 10.448 24 11C24 11.552 24.448 12 25 12C25.551 12 26 12.449 26 13V15C26 15.551 25.551 16 25 16H23.828C23.526 15.149 22.851 14.474 22 14.172V10C22 6.692 19.308 4 16 4C12.692 4 10 6.692 10 10V14.172C9.149 14.474 8.474 15.149 8.172 16H7C6.449 16 6 15.551 6 15V13C6 12.449 6.449 12 7 12C7.551 12 8 11.552 8 11C8 10.448 7.552 10 7 10C5.346 10 4 11.346 4 13V15C4 16.654 5.346 18 7 18H8.172C8.585 19.164 9.696 20 11 20H15V22C12.243 22 10 24.243 10 27C10 27.552 10.448 28 11 28C11.552 28 12 27.552 12 27C12 25.346 13.346 24 15 24V25C15 25.552 15.448 26 16 26C16.552 26 17 25.552 17 25V24C18.654 24 20 25.346 20 27C20 27.552 20.448 28 21 28C21.552 28 22 27.552 22 27C22 24.243 19.757 22 17 22V20H21C22.304 20 23.415 19.164 23.828 18H25C26.654 18 28 16.654 28 15V13C28 11.346 26.654 10 25 10ZM12 10C12 7.794 13.794 6 16 6C18.206 6 20 7.794 20 10V14H12V10ZM21 18H11C10.449 18 10 17.551 10 17C10 16.449 10.449 16 11 16H21C21.551 16 22 16.449 22 17C22 17.551 21.551 18 21 18Z" />
	</svg>
);

export default Chair;
